export default __webpack_public_path__ + "static/media/VISUAL_AND_PERFORMING_ARTS_REMIX.f1b0c9a9.svg";